/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import { get as userGet } from 'js/lib/user';

import ExploreSubPage from 'bundles/composable-page-header/components/mobile-menu-items/ExploreSubPage';
import MobileBackNavHeader from 'bundles/composable-page-header/components/mobile-menu-items/MobileBackNavHeader';
import type { MobileExploreIdentifierValues } from 'bundles/composable-page-header/constants';
import { MOBILE_EXPLORE_IDENTIFIER } from 'bundles/composable-page-header/constants';
import { MegaMenuDataProviderWithHOC } from 'bundles/composable-page-header/providers/MegaMenuDataProvider';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';
import type { MenuItem } from 'bundles/megamenu/types/MenuData';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  wrapper: css`
    .rc-domainMenu,
    .rc-DegreeMenu,
    .rc-CertificateMenu {
      padding-top: var(--cds-spacing-300) !important;
    }
  `,
};

export const ExploreConsumerSubmenu = () => {
  const [exploreViewState, setExploreViewState] = useState<MobileExploreIdentifierValues>(
    MOBILE_EXPLORE_IDENTIFIER.CONSUMER_EXPLORE_SUBMENU
  );
  const [currentMenuItem, setMenuItem] = useState<MenuItem | undefined>(undefined);
  const mobileBackBtnRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // When entering a subpage, focus on the back button so the page scrolls to the top
    if (mobileBackBtnRef.current instanceof HTMLElement) {
      mobileBackBtnRef.current.focus();
    }
  }, [currentMenuItem, mobileBackBtnRef]);

  return (
    <div css={styles.wrapper}>
      <ExploreSubPage
        exploreViewState={exploreViewState}
        setExploreViewState={setExploreViewState}
        setMenuItem={setMenuItem}
        currentMenuItem={currentMenuItem}
        backToExplore={
          <div ref={mobileBackBtnRef}>
            <MobileBackNavHeader
              label={_t('Explore')}
              trackingName="mobile_header_back_to_explore_submenu_button"
              ariaLabel={_t('Go to Explore navigation slide')}
              onClick={() => setExploreViewState(MOBILE_EXPLORE_IDENTIFIER.CONSUMER_EXPLORE_SUBMENU)}
            />
          </div>
        }
      />
    </div>
  );
};

const WrappedExploreConsumerSubmenu = () => (
  <MegaMenuLinksProvider>
    <MegaMenuDataProviderWithHOC isEnterprise={false} userId={userGet()?.id}>
      <ExploreConsumerSubmenu />
    </MegaMenuDataProviderWithHOC>
  </MegaMenuLinksProvider>
);

export default WrappedExploreConsumerSubmenu;
